import { Grid, Typography } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const EmailFormFields = ({ values, onChange, onTogglePassword, showPassword, setTouched }) => {
  return values.map(item =>
    item.id !== 1 && item.id !== 2 && item.id !== 8 ? (
      <Grid my="22px" key={item.id}>
        <Typography variant="h6" color="#23283a" fontWeight={600} pb="8px">{item.title}</Typography>
        <Grid sx={{ position: 'relative' }}>
          <input
            type={item.type}
            placeholder={item.placeholder}
            name={item.name}
            value={item.value}
            onChange={(e) => onChange(e, item.id)}
            onBlur={() => {
              const updated = [...values];
              const index = updated.findIndex(i => i.id === item.id);
              updated[index].touched = true;
              setTouched(updated);
            }}
            style={{
              border: `1px solid ${item.touched && item.value.trim() === '' ? '#d53049' : '#d8dae9'}`,
              backgroundColor: 'white',
              borderRadius: '4px',
              padding: '9px 12px',
              width: '100%',
              fontSize: '14px',
            }}
          />
          {item.name === 'Password' && (
            <Grid onClick={onTogglePassword} sx={{ position: 'absolute', top: '13px', left: '2%', cursor: 'pointer' }}>
              <RemoveRedEyeIcon style={{ color: 'darkgray' }} />
            </Grid>
          )}
        </Grid>
        {item.touched && item.value.trim() === '' && (
          <Typography variant="body1" fontWeight={700} color="#d53049" pt="8px">{item.error}</Typography>
        )}
        {item.touched && item.value.trim() !== '' && item.typeError && (
          <Typography variant="body1" fontWeight={700} color="#d53049" pt="8px">{item.typeError}</Typography>
        )}
      </Grid>
    ) : null
  );
};

export default EmailFormFields;
